import axiosInstance from '../services/AxiosInstance';

export function getSteps(data) {
    return axiosInstance.post(`onboarding/search`, data);
}

